import styled from "styled-components";

export const Container = styled.div<{ isError?: boolean }>`
	width: 380px;
	padding: 20px;
	margin: 0 auto 0px;
	background: ${p => p.theme.colors.background};
	border-top: solid 2px ${p => p.isError ? p.theme.colors.error : p.theme.colors.primary};
	position: relative;
`;